export const formatM2MTitle = (title: string, isRomanBlind = false) => {
  if (isRomanBlind) return title.replace(" Curtains or", "");
  else return title.replace(" or Roman Blind", "");
};
